(function () {
  'use strict';

  function initFlagship(root) {
    if (!root || root.getAttribute('data-nf-initialized')) return;
    root.setAttribute('data-nf-initialized', 'true');

    // ---------- reveal + fill-text on scroll into view ----------
    var revealEls = root.querySelectorAll('.nf-reveal, .nf-fill-text');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) entry.target.classList.add('nf-in');
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
      );
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('nf-in'); });
    }

    // ---------- gallery lightbox ----------
    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-nf-gallery-trigger]'));
    var lightbox = root.querySelector('[data-nf-lightbox]');
    if (!triggers.length || !lightbox) return;

    var imgEl = lightbox.querySelector('[data-nf-lightbox-image]');
    var captionEl = lightbox.querySelector('[data-nf-lightbox-caption]');
    var closeBtn = lightbox.querySelector('[data-nf-lightbox-close]');
    var prevBtn = lightbox.querySelector('[data-nf-lightbox-prev]');
    var nextBtn = lightbox.querySelector('[data-nf-lightbox-next]');
    var currentIndex = 0;

    function slides() {
      return triggers.map(function (t) {
        var img = t.querySelector('img');
        var captionNode = t.querySelector('.nf-gallery-caption');
        return {
          src: img ? (img.currentSrc || img.src) : '',
          alt: img ? img.alt : '',
          caption: captionNode ? captionNode.textContent : ''
        };
      });
    }

    function show(index) {
      var data = slides();
      if (!data.length) return;
      currentIndex = (index + data.length) % data.length;
      var slide = data[currentIndex];
      if (imgEl) {
        imgEl.src = slide.src;
        imgEl.alt = slide.alt;
      }
      if (captionEl) captionEl.textContent = slide.caption;
    }

    function open(index) {
      show(index);
      lightbox.classList.add('nf-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      lightbox.classList.remove('nf-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    triggers.forEach(function (trigger, i) {
      trigger.addEventListener('click', function () { open(i); });
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (prevBtn) prevBtn.addEventListener('click', function () { show(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(currentIndex + 1); });

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });

    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('nf-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(currentIndex - 1);
      if (e.key === 'ArrowRight') show(currentIndex + 1);
    });
  }

  function boot() {
    document.querySelectorAll('.naseebo-flagship').forEach(initFlagship);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.naseebo-flagship');
    if (root) initFlagship(root);
  });
})();